interface PriceOption {
  id: number;
  price: number | null;
  is_available?: boolean;
}

/** A missing public price is not a zero price or a purchasable variant. */
export function selectProductPrice<T extends PriceOption>(
  prices: T[] = [],
  selectedId?: string | number | null,
  preferAvailable = false,
): T | undefined {
  const validPrices = prices.filter(
    (price) => price.price != null && Number.isFinite(price.price),
  );
  return (
    validPrices.find((price) => price.id === selectedId) ??
    (preferAvailable ? validPrices.find((price) => price.is_available) : undefined) ??
    validPrices[0]
  );
}
